export class PromiseQueue {
  queue = Promise.resolve(true);
  pendingCount = 0;
  bufferLimit;

  constructor(bufferLimit) {
    this.bufferLimit = bufferLimit;
  }

  add(operation) {
    if (this.pendingCount >= this.bufferLimit) {
      return Promise.reject(new Error("Buffer limit reached."));
    }

    this.pendingCount++;

    return new Promise((resolve, reject) => {
      this.queue = this.queue
        .then(operation)
        .then((res) => {
          this.pendingCount--;
          resolve(res);
        })
        .catch((err) => {
          this.pendingCount--;
          reject(err);
        });
    });
  }

  async allSettled() {
    await Promise.allSettled([this.queue]);
  }

  getPendingLength() {
    return this.pendingCount;
  }
}
